import React from "react";
import { getBonus } from "~helpers/getters";
import { generatePlaceholderString } from "~helpers/generators";
import keygen from "~helpers/keygen";
import metaTags from "~constants/metaTags";

export const getMetaTags = (page, isTracker) => 
  // eslint-disable-next-line array-callback-return
   metaTags(page, isTracker).map((meta) => {
    if (meta?.content) {
      return (
        <meta
          key={keygen()}
          {...(meta.name ? { name: meta.name } : { property: meta.property })}
          content={meta.content}
        />
      );
    }
  })
;

export function getCanonicalUrl(page, isTracker) {
  if (page.canonical_url) {
    return `${process.env.GATSBY_SITE_URL}${page.canonical_url}`;
  }
  if (page.path === "/") {
    return process.env.GATSBY_SITE_URL;
  }
  const trailingSlash = process.env.TRAILING_SLASH ? "/" : "";

  return `${process.env.GATSBY_SITE_URL}${page.path.replace(/^\//, "")}${
    !isTracker ? trailingSlash : ""
  }`;
}

export function getRobotOptions(options) {
  if (!options) return null;
  const array = [];
  if (
    !options &&
    !options.page_index &&
    process.env.GATSBY_ACTIVE_ENV !== "development"
  )
    array.push("noindex");
  if (
    !options.links_followed &&
    process.env.GATSBY_ACTIVE_ENV !== "development"
  )
    array.push("nofollow");
  if (!options.images_index && process.env.GATSBY_ACTIVE_ENV !== "development")
    array.push("noimageindex");
  if (!options.show_snippet && process.env.GATSBY_ACTIVE_ENV !== "development")
    array.push("nosnippet");
  if (process.env.GATSBY_ACTIVE_ENV === "development")
    array.push("noindex,follow");
  
  if (process.env.GATSBY_ACTIVE_ENV !== "development" && array.length === 0){
    array.push("index,follow,max-snippet:-1,max-video-preview:-1,max-image-preview:large");
  }
  return array.join();
}

export function getLocale(language) {
  if (language) {
    const locale = language.split("_").reverse();
    locale[1] = locale[1].toUpperCase();
    return locale.join("_");
  }
  return null;
}

export function getTwitterUsername(url) {
  // eslint-disable-next-line no-useless-escape
  const regex = /https?:\/\/(www\.)?twitter\.com\/(#!\/)?@?([^\/]*)/;
  const m = regex.exec(url);

  if (m !== null && m.length >= 3) {
    return m[3];
  }

  return null;
}

export function transformMetaTitle(relation, metaTitle, type) {
  if (type !== "operator") return metaTitle;

  switch (metaTitle) {
    case "[OPERATOR_REVIEW_META_TITLE]":
      return `${relation.name} ${generatePlaceholderString("[YEAR]")} ${
        getBonus("main", relation).one_liner
      }`;
    default:
      return metaTitle;
  }
}
